import { Injectable } from '@angular/core';
import { Route, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { RoleAccessService } from './role.access.service';

@Injectable()
export class AuthGuardService  {
  constructor(private authService: AuthenticationService, private router: Router, public roleService: RoleAccessService) {
  }
  canLoad(route: Route): boolean {
    let url: string = route.path ?? "";
    if (this.authService.isUserLoggedIn()) {
      return true;
    }
    this.authService.setRedirectUrl(url);
    this.router.navigate([this.authService.getLoginUrl()]);
    return false;
  }

  //canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

  //  let url: string = state.url;
  //  if (this.authService.isUserLoggedIn()) {
  //    return true;
  //  }
  //  this.authService.setRedirectUrl(url);
  //  this.router.navigate([this.authService.getLoginUrl()]);
  //  return false;
  //}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    
    let url: string = state.url;
    if (this.authService.isUserLoggedIn()) {
      return this.hasRequiredPermission();
    }
    else {
      this.authService.setRedirectUrl(url);
      this.router.navigate([this.authService.getLoginUrl()]);
      return false;
    }

  }

  //canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {

  //  let url: string = state.url;
  //  
  //  return this.hasRequiredPermission(roleItem, accessType);
  //}



  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    //console.log("Guarding children...");
    return this.canActivate(route, state);
  }

  protected hasRequiredPermission(): Promise<boolean> | boolean {
    // If user’s permissions already retrieved from the API
    
    if (this.roleService.IsPermissionsExists()) {

      return true;
    } else {
      // Otherwise, must request permissions from the API first
      const promise = new Promise<boolean>((resolve, reject) => {
        this.roleService.initializePermissions()
          .then(() => {
            resolve(true);
          }).catch(() => {
            resolve(false);
          });
      });
      return promise;
    }
  }
} 
